/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef } from 'react';
import { Typography, Box, Stack, Slide } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';
import { pluralizeString } from '../../utils/stringUtils';

type Props = React.PropsWithChildren<{
  id: string;
  header?: string;
  section?: string;
  subheader?: string;
  loading?: boolean;
  count?: number;
  countLabel?: string;
  onHeaderClick?: () => void;
  buttons?: React.ReactNode[];
}>;

export const PageHeader: React.FC<Props> = ({
  id,
  header,
  section,
  subheader,
  loading,
  count,
  countLabel = '',
  onHeaderClick,
  buttons,
}) => {
  const countContainerRef = useRef<HTMLDivElement | null>(null);
  const sectionContainerRef = useRef<HTMLDivElement | null>(null);

  const [sectionHeader, setSectionHeader] = React.useState(section);

  useEffect(() => {
    setTimeout(
      () => {
        setSectionHeader(section);
      },
      !!sectionHeader && !section ? 225 : 0,
    );
  }, [section]);

  return (
    <Stack spacing="10px" sx={{ mb: '24px' }}>
      <Stack direction="row" height="31px">
        <Stack id={id} direction="row" spacing="11px" alignItems="end">
          <Stack direction="row" spacing="10px" alignItems="center">
            <Typography
              fontSize="26px"
              fontWeight={800}
              lineHeight="100%"
              sx={section ? { opacity: 0.7, cursor: 'pointer' } : {}}
              onClick={onHeaderClick}
            >
              {header}
            </Typography>
            {!!sectionHeader && (
              <Box ref={sectionContainerRef} sx={{ overflow: 'hidden', ml: '10px' }}>
                <Slide direction="right" in={!!section} unmountOnExit>
                  <Stack direction="row" spacing="10px" alignItems="center">
                    <KeyboardArrowRight sx={{ opacity: 0.7 }} />
                    <Typography fontSize="26px" fontWeight={800} lineHeight="100%">
                      {sectionHeader}
                    </Typography>
                  </Stack>
                </Slide>
              </Box>
            )}
          </Stack>
          {count !== undefined && (
            <Box ref={countContainerRef} sx={{ overflow: 'hidden' }}>
              <Slide direction="right" in={!loading} container={countContainerRef.current}>
                <Typography fontSize="14px" color="#000000" sx={{ height: 'fit-content', opacity: 0.87 }}>
                  {count}
                  {` ${count !== 1 ? pluralizeString(countLabel) : countLabel}`}
                </Typography>
              </Slide>
            </Box>
          )}
        </Stack>
        <Box flex={1} />
        <Stack direction="row" spacing="14px" alignItems="end" sx={{ mb: '-6px', mr: '15px' }}>
          {buttons?.map((button, index) => (
            <React.Fragment key={index}>{button}</React.Fragment>
          ))}
        </Stack>
      </Stack>
      {subheader && <Typography>{subheader}</Typography>}
    </Stack>
  );
};
